import React from 'react';
import { Box, Typography } from '@mui/material';

interface PriorityBadgeProps {
    badgeName: string;
  }
  
  const badgeStyles: Record<string, { color: string; backgroundColor: string }> = {
    High: {
      color: '#f44336',
      backgroundColor: '#ffe6e6',
    },
    Medium: {
      color: '#ff9800',
      backgroundColor: '#fff3e0',
    },
    Low: {
      color: '#4caf50',
      backgroundColor: '#e8f5e9',
    },
    Default: {
      color: '#9e9e9e',
      backgroundColor: '#f5f5f5',
    }
  };
const PriorityBadge: React.FC<PriorityBadgeProps> = ({badgeName}) => {
    const { color, backgroundColor } = badgeStyles[badgeName] || badgeStyles.Default;
  return (
    <Box
      sx={{
        display: 'inline-block',
        px: 2,
        // py: 0.5,
        borderRadius: '999px',
        backgroundColor, // light red background
        border: `1px solid ${color}`,
      }}
    >
      <Typography
        variant="body2"
        sx={{ color, fontWeight: 500 }}
        textAlign={'center'}
      >
        {badgeName}
      </Typography>
    </Box>
  );
};

export default PriorityBadge;
